import Box from 'components/elements/Box';
import React from 'react';
import { IExportJob } from '../shared/shared';
import { ListItem, JobStatus } from '../shared/styles';

interface IViewJobListProps {
  jobs: IExportJob[] | null;
  selectJob: (job: IExportJob) => void;
}
const ViewJobList: React.FC<IViewJobListProps> = ({ jobs, selectJob }) => {
  if (!jobs) return null;
  return (
    <Box>
      <ul>
        {jobs.map((job: IExportJob) => {
          const { description, id, lastRunStatus } = job;
          return (
            <ListItem onClick={(): void => selectJob(job)} key={id}>
              {description || '-'}
              <JobStatus status={lastRunStatus}>{lastRunStatus}</JobStatus>
            </ListItem>
          );
        })}
      </ul>
    </Box>
  );
};

export default ViewJobList;
